import { render, staticRenderFns } from "./NestedDistributionDisplay.vue?vue&type=template&id=9d871952&scoped=true&"
import script from "./NestedDistributionDisplay.vue?vue&type=script&lang=js&"
export * from "./NestedDistributionDisplay.vue?vue&type=script&lang=js&"
import style0 from "./NestedDistributionDisplay.vue?vue&type=style&index=0&id=9d871952&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d871952",
  null
  
)

export default component.exports